import React from 'react';

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';

import logo from 'common/assets/logo.jpg'
import { auth } from 'common/config/Firebase'

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
        width: 120,
        height: 120
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    forgotLink: {
        display: 'block',
        textAlign: 'center',
        color: theme.palette.primary.main,
        cursor: 'pointer',
        fontSize: 14,
        marginTop: -8,
        background: 'none',
        border: 'none',
        padding: 0,
        textDecoration: 'underline',
    },
}));

const LoginBasic = ({handleLoginAction}) => {
    const classes = useStyles();

    const [values, setValues] = React.useState({ mail: '', password: '' });
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [resetEmail, setResetEmail] = React.useState('');
    const [sending, setSending] = React.useState(false);
    const [snack, setSnack] = React.useState({ open: false, msg: '', error: false });

    const handleChange = name => event => {
        setValues({ ...values, [name]: event.target.value });
    };

    const onSubmit = () => handleLoginAction(values['mail'], values['password']);

    const openDialog = () => {
        setResetEmail(values['mail']);
        setDialogOpen(true);
    };

    const handleSendReset = async () => {
        if (!resetEmail.trim()) return;
        setSending(true);
        try {
            await auth.sendPasswordResetEmail(resetEmail.trim());
            setDialogOpen(false);
            setSnack({ open: true, msg: 'Correo de recuperación enviado', error: false });
        } catch (e) {
            const msg = e.code === 'auth/user-not-found'
                ? 'No existe ninguna cuenta con ese correo'
                : 'Error al enviar el correo';
            setSnack({ open: true, msg, error: true });
        } finally {
            setSending(false);
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <img alt="avatar" className={classes.avatar} src={logo}></img>
                <Typography component="h1" variant="h5">
                    Inicia sesión
                </Typography>
                <form className={classes.form} noValidate>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Correo"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={values['mail']}
                        onChange={handleChange('mail')}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Contraseña"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={values['password']}
                        onChange={handleChange('password')}
                    />
                    <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={onSubmit}
                    >
                        Entrar
                    </Button>
                    <button type="button" className={classes.forgotLink} onClick={openDialog}>
                        ¿Has olvidado tu contraseña?
                    </button>
                </form>
            </div>

            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Recuperar contraseña</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" style={{ marginBottom: 16 }}>
                        Introduce tu correo y te enviaremos un enlace para restablecer tu contraseña.
                    </Typography>
                    <TextField
                        label="Correo electrónico"
                        type="email"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={resetEmail}
                        onChange={e => setResetEmail(e.target.value)}
                        onKeyPress={e => e.key === 'Enter' && handleSendReset()}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)} disabled={sending}>Cancelar</Button>
                    <Button onClick={handleSendReset} color="primary" variant="contained" disabled={sending}>
                        {sending ? <CircularProgress size={20} /> : 'Enviar'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={snack.open}
                autoHideDuration={5000}
                onClose={() => setSnack(s => ({ ...s, open: false }))}
                message={snack.msg}
                ContentProps={{ style: { background: snack.error ? '#d32f2f' : '#388e3c' } }}
            />
        </Container>
    );
};

export default LoginBasic;
